import { render, staticRenderFns } from "./Handshake.vue?vue&type=template&id=afb27ac8&"
import script from "./Handshake.vue?vue&type=script&lang=js&"
export * from "./Handshake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports